import React from "react";

import { styled } from "@linaria/react";
import { colors, spacings } from "../Theme";
import { fonts } from "..";
import t from "../i18n";

const Sup = styled.sup`
  color: ${colors.darkNitrogen600};
  vertical-align: top;
`;

const MandatoryLegend = styled.small`
  color: ${colors.darkNitrogen600};
  font: ${fonts.body3};
  display: none;

  form:has(.required) & {
    display: inline;
    margin-top: ${spacings.s};
    margin-bottom: ${spacings.xxs};
  }
`;

const Filler = styled.div`
  height: ${spacings.s};
  form:has(.required) & {
    height: 0px;
  }
`;

interface P extends React.FormHTMLAttributes<HTMLFormElement> {
  afterMandatoryLabel?: React.ReactNode;
}
const Form = ({ children, afterMandatoryLabel, ...props }: P, ref: React.Ref<HTMLFormElement>) => (
  <form {...props} ref={ref}>
    {children}
    <MandatoryLegend>
      <Sup>*</Sup>
      {t("input.mandatory")}
    </MandatoryLegend>
    <Filler />
    {afterMandatoryLabel}
  </form>
);

export default React.forwardRef(Form);
